import { render, staticRenderFns } from "./inline-notification.vue?vue&type=template&id=f1d74ad4&scoped=true&"
import script from "./inline-notification.vue?vue&type=script&lang=js&"
export * from "./inline-notification.vue?vue&type=script&lang=js&"
import style0 from "./inline-notification.vue?vue&type=style&index=0&id=f1d74ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d74ad4",
  null
  
)

export default component.exports